import { render, staticRenderFns } from "./PersonSkillsReviewConf.vue?vue&type=template&id=5b9cf17f"
import script from "./PersonSkillsReviewConf.vue?vue&type=script&lang=js"
export * from "./PersonSkillsReviewConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports